import { PreviewStatementDatasetSource } from "../previewTypes";

export const BALANCE_SHEET_DATASET: PreviewStatementDatasetSource = {
    shape: "statement",
    accountHeader: "Account",
    percentHeader: "% of total",
    percentBase: 3022648.42,
    rows: [
        { id: "assets", label: "Assets", kind: "section" },
        {
            id: "checking",
            label: "Checking",
            kind: "line",
            amount: 1180198.42,
        },
        { id: "savings", label: "Savings", kind: "line", amount: 500000 },
        {
            id: "accounts-receivable",
            label: "Accounts Receivable",
            kind: "line",
            amount: 402450,
        },
        {
            id: "undeposited-funds",
            label: "Undeposited Funds",
            kind: "line",
            amount: 0,
            hasActivity: true,
        },
        {
            id: "prepaid-expenses",
            label: "Prepaid Expenses",
            kind: "line",
            amount: 0,
        },
        {
            id: "ppe",
            label: "Property, Plant & Equipment",
            kind: "line",
            amount: 940000,
        },
        {
            id: "total-assets",
            label: "Total Assets",
            kind: "total",
            amount: 3022648.42,
            hasTopBorder: true,
        },
        { id: "liabilities", label: "Liabilities", kind: "section" },
        {
            id: "accounts-payable",
            label: "Accounts Payable",
            kind: "line",
            amount: 145380,
        },
        {
            id: "total-liabilities",
            label: "Total Liabilities",
            kind: "total",
            amount: 145380,
            hasTopBorder: true,
        },
        { id: "equity", label: "Equity", kind: "section" },
        {
            id: "owners-equity",
            label: "Owner's Equity",
            kind: "line",
            amount: 2970940,
        },
        {
            id: "net-income",
            label: "Net Income",
            kind: "line",
            amount: -93671.58,
        },
        {
            id: "total-equity",
            label: "Total Equity",
            kind: "total",
            amount: 2877268.42,
            hasTopBorder: true,
        },
        {
            id: "total-liabilities-equity",
            label: "Total Liabilities and Equity",
            kind: "total",
            amount: 3022648.42,
            hasTopBorder: true,
        },
    ],
};
